import { useAdjustmentsEnabled } from '../adjustments-context';
import { useHiddenFields } from '../issue-adjustments/hooks';

export const useEnabledHiddenFields = () => {
	const adjustmentsAreEnabled = useAdjustmentsEnabled();
	const hiddenFields = useHiddenFields();

	if (!adjustmentsAreEnabled) {
		return [];
	}
	return hiddenFields;
};
